/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type organization_organization$ref: FragmentReference;
declare export opaque type organization_organization$fragmentType: organization_organization$ref;
export type organization_organization = {|
  +rowId: any,
  +name: string,
  +avatar: ?string,
  +canUpdate: ?boolean,
  +isLeader: ?boolean,
  +account: ?{|
    +members: {|
      +totalCount: number
    |}
  |},
  +collaborators: {|
    +totalCount: number
  |},
  +teams: {|
    +totalCount: number
  |},
  +bots: {|
    +totalCount: number
  |},
  +$refType: organization_organization$ref,
|};
export type organization_organization$data = organization_organization;
export type organization_organization$key = {
  +$data?: organization_organization$data,
  +$fragmentRefs: organization_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "organization_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatar",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canUpdate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MembersConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UsersConnection",
      "kind": "LinkedField",
      "name": "collaborators",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamsConnection",
      "kind": "LinkedField",
      "name": "teams",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BotsConnection",
      "kind": "LinkedField",
      "name": "bots",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Organization"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f6faad683675483c07d30676a408d4cb';

module.exports = node;
